import { z } from 'zod';

export const editCampagneInfoFormSchema = z.object({
  annee: z.string().optional(),
  dateDebutInscription: z.string().min(1, 'La date d\'ouverture des inscriptions est obligatoire'),
  dateOuvertureDepot: z.string().min(1, 'La date d\'ouverture des dépôts est obligatoire'),
  dateClotureDepot: z.string().min(1, 'La date de clôture est obligatoire'),
}).superRefine((form, ctx) => {
  const dateDebutInscription = new Date(form.dateDebutInscription);
  const dateOuvertureDepot = new Date(form.dateOuvertureDepot);
  const dateClotureDepot = new Date(form.dateClotureDepot);

  if (form.annee) {
    const annee = parseInt(form.annee, 10);
    const dateDebutAnnee = new Date(annee, 0, 1);
    const dateFinAnnee = new Date(annee, 11, 31, 23, 59, 59, 999);

    if (dateDebutInscription < dateDebutAnnee || dateDebutInscription > dateFinAnnee) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `La date de début d'inscription doit être comprise entre le 1er janvier ${annee} et le 31 décembre ${annee}`,
        path: ['dateDebutInscription'],
      });
    }

    if (dateOuvertureDepot < dateDebutAnnee || dateOuvertureDepot > dateFinAnnee) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `La date d'ouverture du dépôt doit être comprise entre le 1er janvier ${annee} et le 31 décembre ${annee}`,
        path: ['dateOuvertureDepot'],
      });
    }

    if (dateClotureDepot < dateDebutAnnee || dateClotureDepot > dateFinAnnee) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `La date de clôture du dépôt doit être comprise entre le 1er janvier ${annee} et le 31 décembre ${annee}`,
        path: ['dateClotureDepot'],
      });
    }
  }

  if (dateOuvertureDepot < dateDebutInscription) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message:
        'La date d\'ouverture du dépôt doit être postérieure à la date de début d\'inscription',
      path: ['dateOuvertureDepot'],
    });
  }

  if (dateClotureDepot < dateDebutInscription) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message:
        'La date de clôture du dépôt doit être postérieure à la date de début d\'inscription',
      path: ['dateClotureDepot'],
    });
  }

  if (dateClotureDepot < dateOuvertureDepot) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message:
        'La date de clôture du dépôt doit être postérieure à la date d\'ouverture du dépôt',
      path: ['dateClotureDepot'],
    });
  }
});

export type EditCampagneInfoFormResult = z.infer<typeof editCampagneInfoFormSchema>